import React, { useState } from "react";
import { ReactComponent as AngleDownIcon } from '../../../assets/icons/angle-down.svg';
import s from "../advantages.module.scss";

const AdvantageItem = (props) => {

    const [isShowBlock, setIsShowBlock] = useState(false);

    const showBlock = () => {
        setIsShowBlock(!isShowBlock)
    }

    return (
            <div className={s.AdvantagesBlock} key={props.index} onClick={showBlock}>
                <div className={s.titleBlock}>
                    <div className={s.iconBlock}>
                        { props.getIconByTitle(props.title) }
                    </div>
                    <span>{props.getValue(props.title)}</span>
                    <button className={s.toggleButton} style={isShowBlock ? {transform: 'rotate(180deg)'} : {transform: 'rotate(0deg)'}}>
                        <AngleDownIcon />
                    </button>
                </div>
                <div className={s.textBlock} hidden={!isShowBlock}>
                    <span>{props.getValue(props.text)}</span>
                </div>
            </div>
    )
}

export default AdvantageItem;